import { TOAST_REMOVE_DELAY } from '../config/constants';
import { dispatch } from './dispatch';

const toastTimeouts = new Map<string, ReturnType<typeof setTimeout>>();

export function addToRemoveQueue(toastId: string) {
  if (toastTimeouts.has(toastId)) {
    return;
  }

  const timeout = setTimeout(() => {
    toastTimeouts.delete(toastId);
    dispatch({
      type: 'REMOVE_TOAST',
      toastId: toastId,
    });
  }, TOAST_REMOVE_DELAY);

  toastTimeouts.set(toastId, timeout);
}
